export default __webpack_public_path__ + "static/media/step_1_dont_3.d2501e62.jpg";